import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ValueListItemDTO } from 'src/app/Common/ValueListService/value-list-item.interface';
import { ValueListService } from 'src/app/Common/ValueListService/value-list.service';

@Component({
  selector: 'app-valuelist-selector',
  templateUrl: './valuelist-selector.component.html',
  styleUrls: ['./valuelist-selector.component.css']
})
export class ValuelistSelectorComponent {
  @Input({ required: true }) control!: FormControl;
  @Input({ required: true }) vlCode!: string;
  @Input() placeholder: string = 'Select an option';
  @Output() onBlur: EventEmitter<void> = new EventEmitter<void>();

  valueListItems: ValueListItemDTO[] = [];

  constructor(private valueListService: ValueListService) { }

  ngOnInit(): void {
    if (this.vlCode) {
      this.loadValueListItems();
    }
  }

  private loadValueListItems() {
    this.valueListService.getItemByVLCode(this.vlCode).subscribe(items => {
      this.valueListItems = items;
    });
  }
}
